import { render, staticRenderFns } from "./CurrentTimeDisplay.vue?vue&type=template&id=e2d47e20&scoped=true&"
import script from "./CurrentTimeDisplay.vue?vue&type=script&lang=js&"
export * from "./CurrentTimeDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d47e20",
  null
  
)

export default component.exports